export default __webpack_public_path__ + "static/media/frame_4.9cecd589.png";